import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import API from "../services/api";
import { fetchOtAllocationStatus } from "../Moduels/attendance/attendanceApi";
import {
  OT_HOURS_ALLOCATION_CONFIG_EVENT,
  otHoursAllocationEnabledFromExtraWork,
} from "../Moduels/attendance/otHoursAllocationEvents";
import { queryClient } from "../lib/queryClient";
import { orgScope } from "../services/orgScope";

async function resolveOtHoursAllocationEnabled() {
  try {
    const st = await fetchOtAllocationStatus();
    return Boolean(st?.enabled);
  } catch {
    try {
      const res = await API.get("/organisation/me/extra-work-config");
      return otHoursAllocationEnabledFromExtraWork(res.data?.extra_work);
    } catch {
      return false;
    }
  }
}

/**
 * OT Hours Allocation nav is shown only when Extra Work → processing.ot_hours_allocation_enabled is on.
 * Listens for instant updates from the Extra Work settings page (toggle + save).
 */
export function useOtHoursAllocationNav() {
  const scope = orgScope();
  const queryKey = ["ot-allocation-nav", scope];
  const query = useQuery({
    queryKey,
    queryFn: resolveOtHoursAllocationEnabled,
    staleTime: 60_000,
    retry: 1,
    enabled: scope !== "anonymous",
  });

  useEffect(() => {
    const key = ["ot-allocation-nav", scope];
    const onConfig = (e) => {
      const instant = e?.detail?.enabled;
      if (typeof instant === "boolean") {
        queryClient.setQueryData(key, instant);
        return;
      }
      queryClient.invalidateQueries({ queryKey: key });
    };

    window.addEventListener(OT_HOURS_ALLOCATION_CONFIG_EVENT, onConfig);
    return () => {
      window.removeEventListener(OT_HOURS_ALLOCATION_CONFIG_EVENT, onConfig);
    };
  }, [scope]);

  return {
    loaded: scope === "anonymous" || query.isSuccess || query.isError,
    enabled: Boolean(query.data),
  };
}
